import CategoriesDropdown from "pages/ManagementPage/CategoriesDropdown/CategoriesDropdown";

export default CategoriesDropdown;
